import { render, staticRenderFns } from "./Movimiento-de-stock.vue?vue&type=template&id=2a062343&scoped=true"
import script from "./Movimiento-de-stock.vue?vue&type=script&lang=js"
export * from "./Movimiento-de-stock.vue?vue&type=script&lang=js"
import style0 from "./Movimiento-de-stock.vue?vue&type=style&index=0&id=2a062343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a062343",
  null
  
)

export default component.exports